import { AuthenticationCallback, Authenticator,AuthInfo, SignInInfo, UserInfo } from '@amzn/awscat-portal-authentication-library';
import React from 'react';

export interface AuthContextInterface {
    auth: Authenticator;
}

const dummyAuthenticatorErrorMessage = 'Cannot use auth context without an auth context provider';

const dummyAuthenticator: Authenticator = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    signInWithQueryParameters: (queryParameters: string): Promise<SignInInfo> => {
        throw new Error(dummyAuthenticatorErrorMessage);
    },
    refreshToken: (): Promise<AuthInfo> => {
        throw new Error(dummyAuthenticatorErrorMessage);
    },
    redirectToSignOut: () => {
        throw new Error(dummyAuthenticatorErrorMessage);
    },
    redirectToSignIn: () => {
        throw new Error(dummyAuthenticatorErrorMessage);
    },
    authenticate: (): Promise<AuthInfo> => {
        throw new Error(dummyAuthenticatorErrorMessage);
    },
    isAuthenticated: (): boolean => {
        throw new Error(dummyAuthenticatorErrorMessage);
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getToken: (refeshIfRequired: boolean): Promise<string> => {
        throw new Error(dummyAuthenticatorErrorMessage);
    },
    getProvider: (): string => {
        throw new Error(dummyAuthenticatorErrorMessage);
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setCallback: (callback: AuthenticationCallback) => {
        throw new Error(dummyAuthenticatorErrorMessage);
    },
    getUserInfo: (): UserInfo => {
        throw new Error(dummyAuthenticatorErrorMessage);
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getUserInfoList: (userIds: string[]): Promise<UserInfo[]> => {
        throw new Error(dummyAuthenticatorErrorMessage);
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    searchUserInfoByEmail: (email: string): Promise<UserInfo[]> => {
        throw new Error(dummyAuthenticatorErrorMessage);
    },
};

const AuthContext = React.createContext<AuthContextInterface>({auth: dummyAuthenticator});

function withAuthContext(Component: any) {
    return function AuthContextComponent(props: any): JSX.Element {
        return (
            <AuthContext.Consumer>
                {ctx => <Component {...props} appContext={ctx} auth={ctx.auth} />}
            </AuthContext.Consumer>);
    };
}

export { AuthContext, withAuthContext };
